
    import React from 'react';
    import OccurrenceTypeListPageContainer from './ZipCodeRangeListPageContainer';
    
    export class ZipCodeRangeListPage extends React.Component{
        
        render(){
          return (
            <OccurrenceTypeListPageContainer {...this.props}/>
          )
        }
    }